import { request } from "../../apis";

export const apiGetSupportedPhoneBrands = (params: any): any =>
  request("get", `/api/phone/support/brand`, params, false);

export const apiGetSupportedPhonModelList = (params: any): any =>
  request("get", `/api/phone/brand/model`, params, false);
